import React, { Suspense } from 'react'
import {
     Route,
     Switch,
     Redirect
} from 'react-router-dom';
import { CContainer } from '@coreui/react';

// routes config
import { supportRoutes } from '../../routes';
import CenterSpinner from '../../components/general/Loadings/CenterSpinner';
import CFade from '../../components/migration/CFade';

const SupportContent = () => {
     const routes = supportRoutes;

     return (
          <main className="c-main" style={{ paddingTop: '2rem' }}>
               <CContainer fluid>
                    <Suspense fallback={<CenterSpinner />}>
                         <Switch>
                              {routes.map((route, idx) => {
                                   return route.component && (
                                        <Route
                                             key={idx}
                                             path={route.path}
                                             exact={route.exact}
                                             name={route.name}
                                             render={props => (
                                                  <CFade>
                                                       <route.component {...props} />
                                                  </CFade>
                                             )} />
                                   )
                              })}
                              <Redirect to='/' />
                         </Switch>
                    </Suspense>
               </CContainer>
          </main>
     )
}

export default React.memo(SupportContent)
